import { array, date, number, object, string } from "yup"
import { ID, ID2 } from "./yup.common"

export const addScheduleModel = object({
  date: date().required("Please select a date!"),
  plotCommodityRequirements: array(
    object({
      plotCommodity: ID2("Plot Commodity").required(
        "Please enter Plot Commodity!"
      ),
      estimatedQuantity: number()
        .positive("Quantity should be atleast 0!")
        .required("Please enter quantity!"),
      skuType: ID2("SKU Type").required("Please enter SKU Type!"),
    })
  ).min(1),
})

export const updateSchedulesModel = object({
  schedules: array(
    object({
      rowId: ID.label("Schedule").label(
        "Schedule could not be recorded, please try again"
      ),
      aggregatorId: ID.required("Please enter the aggregator!").label(
        "Aggregator"
      ),
      labourCount: number()
        .integer("Please enter a valid count!")
        .min(0, "Number of labours should be atleast 0!")
        .label("Labout"),
      vehicleId: ID2("Vehicle").required("Please enter the vehicle!"),
      requiredQuantity: number()
        .min(0, "Required quantity should be atleast 0!")
        .label("Required Quantity")
        .required("Please enter required quantity!"),
      farmWeight: number()
        .min(0, "Farm weight should be atleast 0!")
        .label("Farm Weight"),
      farmQuantityUnit: ID.nullable(),
      skuType: ID2("Please Enter SKU Type").required("SKU Type is required!"),
      sourceDepot: ID2("Please enter source depot!").required(
        "Source depot is required!"
      ),
      destinationDepot: ID2("Please enter destination depot!").required(
        "Destination depot is required!"
      ),
    })
  ),
})

export const validateSchedules = array(
  object({
    vehicle: object()
      .required("Vehicle is required for the schedule")
      .typeError("Please Enter a valid vehicle!"),
    aggregator: object()
      .required("Aggregator is required for the schedule!")
      .typeError("Please select a valid aggregator!"),
    requiredQuantity: number()
      .required("SKU Quantity is required!")
      .positive("Please enter valid SKU Quantity!"),
    farmWeight: number()
      .required("UOM Quantity is required!")
      .positive("Please enter valid UOM Quantity!"),
    destinationDepot: object()
      .required("Destination depot is required!")
      .typeError("Please enter valid source depot!"),
    sourceDepot: object()
      .required("Source depot is required!")
      .typeError("Please enter valid source depot!"),
    gradePrices: array()
      .required("Please enter atleast 1 grade price!")
      .min(1, "Please enter atleast 1 grade price!")
      .typeError("Please enter valid grade prices!"),
  })
)

export const addScheduleToTrip = object({
  destinationDepot: ID2("Destination")
    .required("Please enter destination depot")
    .label("Destination Depot"),
  plotCommodityId: ID2("Plot Commodity").required(
    "Please enter plot commodity"
  ),
  skuType: ID2("SKU Type").required("Please enter SKU Type!"),
  requiredQuantity: ID2("Required Quantity")
    .positive("Please enter required quantity greater than 1")
    .required("Please enter required quantity!"),
  tripUuid: string(),
  vehicleLat: number()
    .label("Vehicle Postion")
    .required("Please ensure that the location of the vehicle is availble"),
  vehicleLon: number()
    .label("Vehicle Longitude")
    .required("Please ensure that the location of the vehicle is availble"),
})
